/** 金额以「分」为单位做整数运算，避免浮点误差；单价/数量来自字符串 */

export function parseMoneyToCents(s: string | undefined): number {
  const n = parseFloat(String(s ?? '').replace(/,/g, '').trim());
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** 行总价（元）二位小数字符串；数量或单价无效时返回空串 */
export function lineTotalYuanFromStrings(priceStr: string | undefined, qtyStr: string | undefined): string {
  const priceCents = parseMoneyToCents(priceStr);
  const qty = parseFloat(String(qtyStr ?? '').trim());
  if (!Number.isFinite(qty) || qty <= 0 || priceCents < 0) return '';
  const totalCents = Math.round(priceCents * qty);
  return (totalCents / 100).toFixed(2);
}

export function lineTotalYuanNumber(priceStr: string | undefined, qtyStr: string | undefined): number {
  const priceCents = parseMoneyToCents(priceStr);
  const qty = parseFloat(String(qtyStr ?? '').trim());
  if (!Number.isFinite(qty) || qty <= 0 || priceCents < 0) return 0;
  return Math.round(priceCents * qty) / 100;
}
